import React, { useState } from 'react';
import { Button, Card, StepIndicator, ErrorAlert } from '../../../components/shared';

const STEPS = [
  { key: 'form', label: 'Thông tin' },
  { key: 'otp', label: 'OTP' },
];

const VN_HO = ['Nguyen', 'Tran', 'Le', 'Pham', 'Hoang', 'Huynh', 'Phan', 'Vu', 'Vo', 'Dang', 'Bui', 'Do', 'Ho', 'Ngo', 'Duong', 'Ly'];
const VN_DEM_NAM = ['Van', 'Duc', 'Minh', 'Quoc', 'Hoang'];
const VN_DEM_NU = ['Thi', 'Ngoc', 'Thanh', 'Xuan'];
const VN_TEN_NAM = ['Anh', 'Bao', 'Cuong', 'Dat', 'Dung', 'Hai', 'Hieu', 'Hung', 'Huy', 'Khanh', 'Long', 'Minh', 'Nam', 'Phuc', 'Quan', 'Son', 'Tai', 'Thanh', 'Thinh', 'Tuan'];
const VN_TEN_NU = ['Anh', 'Chi', 'Dung', 'Ha', 'Hang', 'Hanh', 'Hoa', 'Huong', 'Lan', 'Linh', 'Mai', 'My', 'Nga', 'Nhi', 'Oanh', 'Phuong', 'Thao', 'Thu', 'Trang', 'Vy'];
const VN_STREETS = ['Nguyen Trai', 'Le Loi', 'Tran Hung Dao', 'Ly Thuong Kiet', 'Ba Trieu', 'Hai Ba Trung', 'Nguyen Du'];

function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
function randDigits(len) { let s = ''; for (let i = 0; i < len; i++) s += Math.floor(Math.random() * 10); return s; }
function randDate(minY, maxY) {
  const y = minY + Math.floor(Math.random() * (maxY - minY + 1));
  const m = String(1 + Math.floor(Math.random() * 12)).padStart(2, '0');
  const d = String(1 + Math.floor(Math.random() * 28)).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
function findCode(list, keyword) {
  const item = list.find((i) => (i.name || '').toLowerCase().includes(keyword));
  return item ? (item.code || item.value || '') : '';
}

function generateAutoFillData(currentForm, catalogs) {
  const { provinces = [], banks = [], nationalities = [], issuePlaces = [] } = catalogs || {};
  const isMale = currentForm.gender !== 'F';
  const ho = rand(VN_HO);
  const dem = isMale ? rand(VN_DEM_NAM) : rand(VN_DEM_NU);
  const ten = isMale ? rand(VN_TEN_NAM) : rand(VN_TEN_NU);
  const fullName = `${ho} ${dem} ${ten}`;
  const emailName = `${ho}${ten}${randDigits(3)}`.toLowerCase();

  return {
    fullName,
    gender: isMale ? 'M' : 'F',
    dateOfBirth: randDate(1985, 2002),
    idNumber: '0' + randDigits(11),
    idIssueDate: randDate(2020, 2025),
    idIssuePlace: findCode(issuePlaces, 'cục') || (issuePlaces[0]?.code || ''),
    nationality: findCode(nationalities, 'vietnam') || findCode(nationalities, 'việt') || 'VN',
    permanentAddress: `${Math.floor(Math.random() * 200) + 1} ${rand(VN_STREETS)}`,
    provinceId: findCode(provinces, 'hồ chí minh') || findCode(provinces, 'hà nội') || (provinces[0]?.code || ''),
    phoneNumber: '09' + randDigits(8),
    email: `${emailName}@gmail.com`,
    bankId: findCode(banks, 'vietcombank') || findCode(banks, 'vcb') || (banks[0]?.code || ''),
    bankBranch: 'Ho Chi Minh',
    bankAccountNo: randDigits(13),
    bankAccountName: fullName.toUpperCase(),
  };
}

const SPARKLE_ICON = (
  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
  </svg>
);

function ManualFormStep({ catalogs, onSubmit, loading, error }) {
  const { provinces = [], banks = [], nationalities = [], issuePlaces = [] } = catalogs || {};

  const [form, setForm] = useState({
    fullName: '',
    gender: '',
    dateOfBirth: '',
    idNumber: '',
    idIssueDate: '',
    idIssuePlace: '',
    nationality: 'VN',
    permanentAddress: '',
    provinceId: '',
    phoneNumber: '',
    email: '',
    bankId: '',
    bankBranch: '',
    bankAccountNo: '',
    bankAccountName: '',
  });

  const update = (field) => (e) => {
    const val = typeof e === 'string' ? e : e.target.value;
    setForm((f) => ({ ...f, [field]: val }));
  };

  const handleAutoFill = () => {
    const data = generateAutoFillData(form, catalogs);
    setForm((f) => ({ ...f, ...data }));
  };

  const canSubmit = form.fullName && form.idNumber && form.phoneNumber && form.email
    && form.dateOfBirth && form.gender;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  const inputClass = 'w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500';
  const selectClass = 'w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500';

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Thông tin cá nhân</h3>
          <p className="mt-1 text-sm text-gray-500">Nhập đầy đủ thông tin để mở tài khoản chứng khoán</p>
        </div>
        <button
          type="button"
          onClick={handleAutoFill}
          title="Auto fill"
          className="shrink-0 rounded-lg border border-gray-200 p-2 text-gray-400 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-600"
        >
          {SPARKLE_ICON}
        </button>
      </div>

      <div className="space-y-4">
        <div>
          <label className="mb-1.5 block text-sm font-medium text-gray-700">Họ tên *</label>
          <input type="text" value={form.fullName} onChange={update('fullName')} placeholder="Nguyễn Văn A" className={inputClass} required />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Giới tính *</label>
            <select value={form.gender} onChange={update('gender')} className={selectClass} required>
              <option value="">Chọn</option>
              <option value="M">Nam</option>
              <option value="F">Nữ</option>
            </select>
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Ngày sinh *</label>
            <input type="date" value={form.dateOfBirth} onChange={update('dateOfBirth')} className={inputClass} required />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Số CMND/CCCD *</label>
            <input type="text" value={form.idNumber} onChange={update('idNumber')} placeholder="0123456789" className={inputClass} required />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Ngày cấp</label>
            <input type="date" value={form.idIssueDate} onChange={update('idIssueDate')} className={inputClass} />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Nơi cấp</label>
            <select value={form.idIssuePlace} onChange={update('idIssuePlace')} className={selectClass}>
              <option value="">Chọn nơi cấp</option>
              {issuePlaces.map((p) => (
                <option key={p.code || p.value} value={p.code || p.value}>{p.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Quốc tịch</label>
            <select value={form.nationality} onChange={update('nationality')} className={selectClass}>
              {nationalities.map((n) => (
                <option key={n.code || n.value} value={n.code || n.value}>{n.name}</option>
              ))}
              {nationalities.length === 0 && <option value="VN">Việt Nam</option>}
            </select>
          </div>
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-gray-700">Địa chỉ thường trú</label>
          <input type="text" value={form.permanentAddress} onChange={update('permanentAddress')} placeholder="Số nhà, đường, phường/xã" className={inputClass} />
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-gray-700">Tỉnh/Thành phố</label>
          <select value={form.provinceId} onChange={update('provinceId')} className={selectClass}>
            <option value="">Chọn tỉnh/thành</option>
            {provinces.map((p) => (
              <option key={p.code || p.value} value={p.code || p.value}>{p.name}</option>
            ))}
          </select>
        </div>

        <hr className="border-gray-100" />

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Số điện thoại *</label>
            <input type="tel" value={form.phoneNumber} onChange={update('phoneNumber')} placeholder="0912345678" className={inputClass} required />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Email *</label>
            <input type="email" value={form.email} onChange={update('email')} placeholder="email@example.com" className={inputClass} required />
          </div>
        </div>

        <hr className="border-gray-100" />
        <p className="text-xs font-medium uppercase tracking-wide text-gray-500">Thông tin ngân hàng</p>

        <div>
          <label className="mb-1.5 block text-sm font-medium text-gray-700">Ngân hàng</label>
          <select value={form.bankId} onChange={update('bankId')} className={selectClass}>
            <option value="">Chọn ngân hàng</option>
            {banks.map((b) => (
              <option key={b.code || b.value} value={b.code || b.value}>{b.name}</option>
            ))}
          </select>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Số tài khoản</label>
            <input type="text" value={form.bankAccountNo} onChange={update('bankAccountNo')} placeholder="Số TK ngân hàng" className={inputClass} />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">Tên chủ TK</label>
            <input type="text" value={form.bankAccountName} onChange={update('bankAccountName')} placeholder="Tên chủ tài khoản" className={inputClass} />
          </div>
        </div>
      </div>

      <ErrorAlert error={error} />

      <Button className="w-full" type="submit" loading={loading} disabled={!canSubmit}>
        Tiếp tục
      </Button>
    </form>
  );
}

function OtpStep({ onSubmit, loading, error }) {
  const [otp, setOtp] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(otp);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="text-center">
        <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-blue-50">
          <svg className="h-7 w-7 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Nhập mã OTP</h3>
        <p className="mt-1 text-sm text-gray-500">Mã OTP đã được gửi đến số điện thoại hoặc email của bạn</p>
      </div>

      <div>
        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          placeholder="Nhập 6 số OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
          className="w-full rounded-lg border border-gray-300 px-4 py-3 text-center text-2xl font-semibold tracking-widest focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
          autoFocus
        />
      </div>

      <ErrorAlert error={error} />

      <Button className="w-full" type="submit" loading={loading} disabled={otp.length < 6}>
        Xác nhận
      </Button>
    </form>
  );
}

const STEP_MAP = { 'VDSC_MANUAL_FORM': 0, 'VDSC_REGISTER_OTP': 1 };

export default function VdscManualRegisterFlow({
  flowState,
  catalogs,
  onSubmitRegister,
  onSubmitOtp,
  onBack,
  loading,
  error,
}) {
  const currentStep = STEP_MAP[flowState] ?? 0;

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <ManualFormStep catalogs={catalogs} onSubmit={onSubmitRegister} loading={loading} error={error} />;
      case 1:
        return <OtpStep onSubmit={onSubmitOtp} loading={loading} error={error} />;
      default:
        return null;
    }
  };

  return (
    <div className="mx-auto max-w-lg">
      <Card>
        <div className="space-y-6">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Mở tài khoản Rồng Việt</h2>
            <p className="mt-1 text-sm text-gray-500">Nhập thông tin thủ công để mở tài khoản chứng khoán</p>
          </div>

          <StepIndicator steps={STEPS} currentStep={currentStep} />

          {renderStep()}

          <button
            type="button"
            onClick={onBack}
            className="w-full text-center text-sm text-gray-500 hover:text-gray-700"
          >
            Quay lại
          </button>
        </div>
      </Card>
    </div>
  );
}
